import { getQuery } from 'sutils';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { DOC_TYPE } from '../message_const';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';

/** 处理文档元数据 */
export const parseResponse = (response) => {
    if (config.supportEnterprise(EnterPriseType.ALL)) {
        return parseResponseForWecom(response);
    }

    return parseResponseForC(response);
};

// 处理文档元数据
const parseResponseForC = (response) => {
    const data = response.data || {};
    let docType = DOC_TYPE.UNKNOWN;
    let docTitle = '';
    let padId = '';
    if (data.doc_info && data.doc_info.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        const info = data.doc_info[0];
        if (info) {
            docTitle = info.doc_meta?.title;
            padId = info.doc_meta?.doc_id?.pad_id;
        }
        switch (info.doc_meta?.doc_type) {
            case DOC_TYPE.DOC:
                docType = DOC_TYPE.DOC;
                break;
            case DOC_TYPE.SLIDE:
                docType = DOC_TYPE.SLIDE;
                break;
            case DOC_TYPE.PDF:
                docType = DOC_TYPE.PDF;
                break;
            default:
                window.log?.error('doc_info Error', info);
                docType = DOC_TYPE.UNKNOWN;
        }
    } else {
        window.log?.error('checkType Error');
    }
    return {
        docType,
        docTitle,
        padId,
    };
};

// b端处理文档元数据
const parseResponseForWecom = (response) => {
    const data = response.data || {};
    let docType = DOC_TYPE.UNKNOWN;
    const docTitle = data.doc_meta?.title;
    const padId = data.doc_meta?.doc_id?.pad_id;
    switch (data.doc_meta?.doc_type) {
        case DOC_TYPE.DOC:
            docType = DOC_TYPE.DOC;
            break;
        case DOC_TYPE.SLIDE:
            docType = DOC_TYPE.SLIDE;
            break;
        case DOC_TYPE.PDF:
            docType = DOC_TYPE.PDF;
            break;
        default:
            window.log?.error('doc_info Error', data.doc_meta?.doc_type);
            docType = DOC_TYPE.UNKNOWN;
    }
    return {
        docType,
        docTitle,
        padId,
    };
};

export const setTitleButtons = () => {
    if (window?.mqq?.ui?.setTitleButtons) {
        window.mqq.ui.setTitleButtons?.({
            right: {
                iconID: 4, // 4代表分享图标
                callback() {
                    // 加这个注册回调，是为了能够手Q横屏旋转。咨询alberthe后目前只能这么办...
                },
            },
        });
    }
};

export const reportPerformanceNow = (msg: string) => {
    console.log(`[reportPerformanceNow]: ${msg}`, Math.floor(performance.now()));
};

export const openVConsoleInDevMobile = () => {
    if (browser.isMobile && process.env.NODE_ENV !== 'production') {
        import('vconsole')
            .then((module) => {
                const VC = module.default;
                new VC(); // 初始化
            })
            .catch((error) => {
                window.log.error(`[loadChunk-error]${error}`);
            });
    }
};

export const getDocId = (): string => {
    const reg = new RegExp('/meetingroom/player/slide/([^/]+?)/?$');
    return reg.exec(location.pathname)?.[1] ?? getQuery('docId');
};
